import { Button, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import { ACCProduct, ACCService } from 'src/@types/cart';
import { useFormatCurrency } from 'src/hooks/useFormatCurrency';
import { useStrings } from 'src/hooks/useStrings';
import { getCartState } from 'src/redux/slices/cart';
import { IdQty } from 'src/sections/@dashboard/POS/POSSaleForm/POSSaleFormTypes';

import Scrollbar from '../Scrollbar';
import { CartItem } from './CartItem';

export enum CartTransactionEnum {
  EXPENSE = 'expense',
  SALE = 'sale',
}

type Props = {
  transactionType: CartTransactionEnum;
  height?: number;
  switchHeight?: VoidFunction;
  currentHeightEqualsHeight?: boolean;
  disablePriceField?: boolean;
  originalItemsQty?: IdQty[];
};

export default function CartTable({
  transactionType,
  height = 295,
  switchHeight,
  currentHeightEqualsHeight,
  disablePriceField,
  originalItemsQty,
}: Props) {
  const { formatCurrency } = useFormatCurrency();
  const { products, services, amountProducts, amountServices } =
    useSelector(getCartState);
  const total = amountProducts + amountServices;
  const { strings } = useStrings();

  return (
    <>
      <Scrollbar
        sx={{
          height,
          backgroundColor: '#fff',
          border: '1px solid #dedede',
          borderRadius: 1,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          padding: 1,
        }}
      >
        {Object.keys(services).map((key, idx) => {
          const service = services[parseInt(key)] as ACCService;

          return (
            <CartItem
              key={service.id}
              transactionType={transactionType}
              data={service}
              itemType="services"
              idx={idx}
            />
          );
        })}
        {Object.keys(products).map((key, idx) => {
          const product = products[parseInt(key)] as ACCProduct;
          const originalProductInSale = originalItemsQty?.find(
            (item) => item.id === product.id
          );
          const originalQtyInSale = originalProductInSale?.qty;

          return (
            <CartItem
              key={product.id}
              transactionType={transactionType}
              data={product}
              itemType="products"
              idx={idx}
              disablePriceField={disablePriceField}
              originalQtyInSale={originalQtyInSale}
            />
          );
        })}
      </Scrollbar>
      <Button
        fullWidth
        variant="contained"
        color="inherit"
        size="small"
        onClick={switchHeight}
        style={{
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        }}
      >
        {currentHeightEqualsHeight ? strings('expand') : strings('collapse')}
      </Button>
      <br />
      <br />
      {transactionType === CartTransactionEnum.SALE && (
        <Stack direction="row" justifyContent="flex-end">
          <Typography>{strings('services')} (+)</Typography>
          <Typography style={{ width: 100, textAlign: 'right' }}>
            {formatCurrency(amountServices)}
          </Typography>
        </Stack>
      )}
      <Stack direction="row" justifyContent="flex-end">
        <Typography>{strings('products')} (+)</Typography>
        <Typography style={{ width: 100, textAlign: 'right' }}>
          {formatCurrency(amountProducts)}
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="flex-end">
        <Typography>Sub total (=)</Typography>
        <Typography style={{ width: 100, textAlign: 'right' }}>
          {formatCurrency(total)}
        </Typography>
      </Stack>
    </>
  );
}
